// @flow
import { TiposSolicitantesActionTypes } from './constants';

type TiposSolicitantesAction = { type: string, payload: {} | string };

// common success
export const tiposSolicitantesApiResponseSuccess = (actionType: string, data: any): TiposSolicitantesAction => ({
    type: TiposSolicitantesActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const tiposSolicitantesApiResponseError = (actionType: string, error: string): TiposSolicitantesAction => ({
    type: TiposSolicitantesActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const getTipoSolicitante = (id: string): TiposSolicitantesAction => ({
    type: TiposSolicitantesActionTypes.GET_TIPO,
    payload: { id },
});

export const addTiposSolicitante = (tiposSolicitante:any):TiposSolicitantesAction=>({
    type:TiposSolicitantesActionTypes.ADD_TIPO,
    payload:tiposSolicitante
})
export const updateTiposSolicitante = (tiposSolicitante:any):TiposSolicitantesAction=>({
    type:TiposSolicitantesActionTypes.UPDATE_TIPO,
    payload:tiposSolicitante
})

export const updateOrderTiposSolicitante = (tiposSolicitante:any):TiposSolicitantesAction=>({
    type:TiposSolicitantesActionTypes.UPDATE_ORDER_TIPOS,
    payload:tiposSolicitante
})

export const deleteTiposSolicitante = (id:string):TiposSolicitantesAction=>({
    type:TiposSolicitantesActionTypes.DELETE_TIPO,
    payload:{id}
})

export const listTiposSolicitantes = (params:any): TiposSolicitantesAction => ({
    type: TiposSolicitantesActionTypes.LIST_TIPOS,
    payload: params,
});

export const setFiltersTiposSolicitantes = (params:any): TiposSolicitantesAction => ({
    type: TiposSolicitantesActionTypes.SET_FILTER,
    payload: params,
})

export const resetTiposSolicitantes = (): TiposSolicitantesAction => ({
    type: TiposSolicitantesActionTypes.RESET,
    payload: {},
});

export const resetSoftTiposSolicitantes = (): TiposSolicitantesAction => ({
    type: TiposSolicitantesActionTypes.RESET_SOFT,
    payload: {},
});
